export enum EventName {
    heartbeat = 'system_heartbeat',
    typing = 'system_typing',
    unreadAdd = 'system_unreadAdd',
    newConversation = 'system_newConversation',
    teamUserAdd = 'system_teamUserAdd',
    teamUserRemove = 'system_teamUserRemove',
    projectUserAdd = 'system_projectUserAdd',
    projectUserRemove = 'system_projectUserRemove',
    projectUsersAdd = 'system_projectUsersAdd',
    projectUsersRemove = 'system_projectUsersRemove',
    notificationAdd = 'system_notificationAdd',
    workspaceUpdated = 'system_workspaceUpdated',
    taskAdd = 'system_taskAdd',
    taskCommentAdd = 'system_taskCommentAdd',
    threadUpdateAsUnread = 'system_threadUpdateAsUnread',
    reloadSubtasks = 'system_reloadSubtasks',
    updateProjectTotals = 'system_updateProjectTotals',
}
